
 
    <div class="container" *ngIf="bool_form_content">
        <div class="row ">
            <div class="col-md-12 ">
                <!--FORM1 Start-->
                <div class="card-body" >

              
                    
                    
                    <p>Candidates Count: {{getTraineCount}}</p>
                    <p>ITI Count: {{getTraineITICount}}</p>

                       <form [formGroup]="itiform" (ngSubmit)="onsubmitITI()">
                          <div class="form-row">
                            
                            <div class="form-group col-6">
                                <label>Start <span class="clr_red"> * </span>
                                </label>
                                <input type="text"  class="form-control"  formControlName="start">
                           
                            </div>
                            <div class="form-group col-6">
                                <label>limit <span class="clr_red"> * </span>
                                </label>
                                <input type="text"  class="form-control" formControlName="limit">
                           
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Click</button>
                                  </div>
                                
                              </div>
                          </div>
                      </form>
                  </div>
                  <!--Form1 End-->

            
            </div>

  
        </div>
    </div>










<div class="container payment_cls">

    <div class="alert alert-success" role="alert" *ngIf="bool_success">
        {{reciveuserstatus}}
      </div>

    <div class="alert alert-danger" role="alert" *ngIf="bool_failure">
        {{reciveuserstatus}}
      </div>
  
    <div class="container" *ngIf="bool_form_content">
        <div class="row ">
            <div class="col-md-6 ">
                <!--FORM1 Start-->
                <div class="card-body" >
                    <!-- <h2>SINGLE / BULK</h2> -->
                      <form [formGroup]="bdnuForm" (ngSubmit)="onSubmit()">
                          <div class="form-row">
                            
                            <div class="form-group col-12">
                                <label>ITI State Upload <span class="clr_red"> * </span>
                                </label>

                                                        <select formControlName="userid" class="form-control"   [ngClass]="{ 'is-invalid': submitted && f.userid.errors }">
                            <option [selected]="true" value="undefined" disabled="true">
                                Please Select Trade
                            </option>
                            <option *ngFor="let a of loginDetail" [value]="a.LoginID">
                                {{ a.LoginID }} -  {{a.statename}}
                            </option>
                        </select>

                        
                                <!-- <input type="text" formControlName="userid" class="form-control"
                                    [ngClass]="{ 'is-invalid': submitted && f.userid.errors }" maxlength="50"
                                    placeholder="Enter Your User ID" (keypress)="omit_spl($event)" /> -->
                                <div *ngIf="submitted && f.userid.errors" class="invalid-feedback">
                                    <div *ngIf="f.userid.errors.required">Enter Your User ID</div>
                                </div>
                            </div>
                             

                          </div>
                          <hr>
                          <div class="form-row">
                              <div class="form-group col-12">
                                  <div class="text-center">
                                      <button class="btn btn-primary mr-1">Click</button>
                                  </div>
                                  <div *ngIf="bool_spinner" class="bg-overlay_cls">
                                    Please Wait...
                                    </div>
                              </div>
                          </div>
                      </form>
                  </div>
                  <!--Form1 End-->

            
            </div>

            <div  class="col-md-6 ">
     <!--FORM3 Start-->
     <div class="card-body"  >
        <form [formGroup]="itiForm" (ngSubmit)="onItiSubmit()">
            <div class="form-row">

              <div class="form-group col-12">
                  <label>State</label>

                  <input type="text" formControlName="statekey" [(ngModel)]="sel_statekey" class="form-control" readonly hidden
                  />
                  <input type="text" formControlName="state" [(ngModel)]="sel_stateName" class="form-control" readonly
                  />
                  <!-- <select formControlName="state" class="form-control"
                    [ngClass]="{ 'is-invalid': submitted && h.state.errors }" (change)="onChangeState($event)">
                    <option [selected]="true" value="" [disabled]="true">Select State</option>
                    <option *ngFor="let country of ListState" [value]="country.statekey">
                      {{ country.statename }}
                    </option>
                  </select>
                  <div *ngIf="submitted && h.state.errors" class="invalid-feedback">
                    <div *ngIf="h.state.errors.required">Select Your State</div>
                  </div> -->
                </div>

              <!-- <div class="form-group col-12">
                  <label>MIS Code <span class="clr_red"> * </span></label>
                  <input type="text" formControlName="iticode" [(ngModel)]="reciveiticode" class="form-control" readonly
                      />
              </div> -->
               

            </div>
            <hr>
            <div class="form-row">
                <div class="form-group col-12">
                    <div class="text-center">
                        <button class="btn btn-primary mr-1">Upload </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <!--FORM3 End-->
            </div>
        </div>
    </div>



</div>
